// src/components/ui/Backdrop.js
import React from 'react';

const Backdrop = ({ onClick }) => (
    <div
        onClick={onClick}
        className="fixed inset-0 bg-black/30 backdrop-blur-sm z-40 animate-fade-in"
    />
);

export default Backdrop;